<template>
  <div class="order-detail">
    <div class="box teal">
      <div class="order">
        <h2>订单号：{{ consignees.orderNo }}</h2>
        <p>收货人：{{ consignees.consignee }}</p>
        <p>联系电话：{{ consignees.consigneePhone }}</p>
        <p>收货地址：{{ consignees.consigneeAddress }}</p>
        <p>下单时间：{{ consignees.orderDate }}</p>
        <p v-if="logisticsCompany">快递公司：{{logisticsCompany}}</p>
        <p v-if="logisticsNo">快递单号：{{logisticsNo}}</p>
        <p class="reason" v-if="consignees.orderStatus === 7 || consignees.orderStatus === 5">取消原因：{{ reason }}</p>
        <p class="reason" v-if="consignees.orderStatus === 10">物流取消：{{ reason }}</p>
        <van-tag round type="success" size="medium" v-if="consignees.orderStatus === 2">待图书馆审核</van-tag>
        <van-tag round type="success" size="medium" v-if="consignees.orderStatus === 3">待供应商确认</van-tag>
        <van-tag round type="primary" size="medium" v-if="consignees.orderStatus === 4">已发货</van-tag>
        <van-tag round type="danger" size="medium" v-if="consignees.orderStatus === 5">图书馆取消</van-tag>
        <van-tag round type="primary" size="medium" v-if="consignees.orderStatus === 6">已收货</van-tag>
        <van-tag round type="danger" size="medium" v-if="consignees.orderStatus === 7">供应商取消</van-tag>
      </div>
    </div>
    <div class="box">
      <div class="header">
        <van-icon name="shop-o"/>
        <span>共<strong>{{ list.length }}</strong>本书</span>
      </div>
      <Book :list="list">
      </Book>
    </div>
  </div>
  <van-submit-bar :price="price * 100">
    <template #button></template>
  </van-submit-bar>
</template>

<script>
import {defineComponent,computed, onMounted, ref} from 'vue';
import Book from './Book';
import {getOrderById} from '@/api/orders';
import {isNotEmpty, setCovers} from '@/utils/util';

export default defineComponent({
  name: 'OrderDetail',
  components: {
    Book,
  },
  props: {
      orderId: {
          type: String,
          default: ''
      }
  },
	setup(props){
      const orderId = computed(() => {
          return props.orderId;
      });
      const logisticsCompany = ref('');
      const logisticsNo = ref('');
      const price = ref(0);
      const consignees = ref({});
      const list = ref([]);
      const reason = ref('');
      const onGetOrderById = ()=>{
          getOrderById(orderId.value)
              .then(data => {
                  if(isNotEmpty(data)){
											if(isNotEmpty(data.bookOrder)){
											    consignees.value = data.bookOrder;
											}
                      if(isNotEmpty(data.openBookList)){
                         const isbns = [];
                          price.value= 0;
													data.openBookList.forEach((item,index) => {
                              if(isNotEmpty(item.book) && isNotEmpty(item.book.isbn)){
                                  isbns.push(item.book.isbn);
                              }
                              if(isNotEmpty(item.book) && item.book.price > 0){
                                  price.value = price.value + item.book.price;
                              }
                              if(index === 0 && isNotEmpty(item.orderDelivery)){
                                  if(isNotEmpty(item.orderDelivery.logisticsCompany)){
                                      logisticsCompany.value = item.orderDelivery.logisticsCompany;
                                  }
                                  if(isNotEmpty(item.orderDelivery.logisticsNo)){
                                      logisticsNo.value = item.orderDelivery.logisticsNo;
                                  }
                              }
                          });
                          if(isNotEmpty(isbns)){
                          	setCovers(isbns,data.openBookList,2);
													}
													list.value = data.openBookList;
                      }
                      if(isNotEmpty(data.reason)){
                          reason.value = data.reason;
                      }
                  }
              })
              .catch((error) => {
                  console.error(error);
              });
      };
      onMounted(() => {
          onGetOrderById();
      });
	    return{
          consignees,
          list,
          price,
          logisticsCompany,
          logisticsNo,
          reason
	    }
	},
});
</script>

<style scoped lang="less">
@import "../assets/css/box.less";
@import "../assets/css/order.less";
.order-detail {
  padding-bottom: 100px;
}
</style>
